<template>
  <v-sheet tile class="support-hero px-4 px-md-8" :class="compact ? 'py-6' : 'py-10 py-md-12'">
    <div class="text-center">
      <h1 :class="compact ? 'text-h5' : 'text-h4'" class="font-weight-medium">
        <v-icon :large="!compact" dark class="mr-2 mb-1">{{ icon }}</v-icon>{{ title }}
      </h1>
      <p v-if="subtitle" class="subtitle-1 mt-1 mb-0">{{ subtitle }}</p>
      <div v-if="$slots.default" class="mt-5"><slot /></div>
      <div class="mt-4">
        <v-btn v-for="b in links" :key="b.title" :to="b.to" outlined dark small class="mx-1 mb-1">
          <v-icon left small>{{ b.icon }}</v-icon>{{ b.title }}
        </v-btn>
      </div>
    </div>
  </v-sheet>
</template>

<script>
/** Full-bleed banner shared by the support centre, FAQ, tickets and manual views. */
export default {
  name: 'SupportHero',
  props: {
    title: { type: String, default: "Centre d'aide" },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: 'mdi-lifebuoy' },
    compact: { type: Boolean, default: false },
  },
  data: () => ({
    links: [
      { title: "Centre d'aide", icon: 'mdi-lifebuoy', to: '/support' },
      { title: 'Tickets', icon: 'mdi-ticket-outline', to: '/tickets' },
      { title: 'FAQ', icon: 'mdi-frequently-asked-questions', to: '/faq' },
    ],
  }),
}
</script>

<style scoped>
.support-hero {
  flex: 0 0 auto;
  background: linear-gradient(135deg, var(--v-primary-base), var(--v-primary-darken1));
  color: #fff;
}
.support-hero h1,
.support-hero p {
  color: #fff;
}
</style>
